import { render } from "./UserRss.vue?vue&type=template&id=da5ec06a"
import script from "./UserRss.vue?vue&type=script&lang=js"
export * from "./UserRss.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__